import React from 'react';

export function SectionCard({
  title,
  icon,
  children,
}: {
  title: string;
  icon: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <div className="border border-border/50 rounded-xl overflow-hidden shadow-sm">
      <div className="flex items-center gap-2.5 px-4 py-3 border-b border-border/40 bg-muted/30">
        <div className="p-1 rounded-md bg-background shadow-sm border border-border/30">
          {icon}
        </div>
        <span className="font-emphasis text-sm tracking-tight text-foreground">{title}</span>
      </div>
      <div className="px-4 py-4 space-y-2">
        {children}
      </div>
    </div>
  );
}

export function InfoRow({ label, value }: { label: string; value: any }) {
  if (!value) return null;
  // Handle {value, sources} objects from LLM merge
  const display = typeof value === 'object' && value?.value !== undefined ? value.value : value;
  if (!display) return null;
  return (
    <div className="py-1.5">
      <span className="text-xs font-medium text-muted-foreground">{label}</span>
      <p className="text-sm text-foreground mt-0.5">{String(display)}</p>
    </div>
  );
}

export function SourceCitation({ source }: { source?: any }) {
  if (!source) return null;
  // Handle {value, sources} objects from LLM merge
  const text: string = typeof source === 'string' ? source : (source?.value || '');
  if (!text) return null;
  const isUrl = text.startsWith('http');
  if (isUrl) {
    return (
      <a href={text} target="_blank" rel="noopener noreferrer" className="text-[10px] text-[#5e6ad2]/70 hover:text-[#5e6ad2] dark:text-[#a5b4fc]/70 dark:hover:text-[#a5b4fc] inline-flex items-center gap-0.5 mt-0.5">
        Source ↗
      </a>
    );
  }
  return <span className="text-[10px] text-muted-foreground italic mt-0.5">Source: {text}</span>;
}
